export enum FormControlNames {
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirmPassword',
}
